module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAApCAYAAABKvBuPAAAA/ElEQVRYR+2YvQ3CMBCFv1uDAShZgQqJhm0Yg21okKgYgZYFGMMoQUH8JPFZcQwKL00Kn8/Pz1/snA0ghLCv3r/4mNmmTZdNQnjX7L6xEg0FLsclPMMSyfEMJial+F/HQwhLYJtkV4Hgl328bVeZgvCTme0KmFkP0cd41ZbiuIR7Vk2OA0JFqEQ+hOYAEipCRah4GHDG6ADSASRU4v++OoCclKiQECpC5b1YBg4trsyABXAFzimuDYxdV/07rkxeq/yBA43SPSa8nl3HMwdWwAU4jqKuJ6mZfVDwuFfpE/N0k1W0AopouqMi4TEXMrULlUxGutOkOu5OXCLwBnvnAfi9o1cSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fangkuai.png
// module id = H7q4
// module chunks = 1